module.exports = __webpack_public_path__ + "static/media/migration.31ac4cea.png";